import { Theme } from '@emotion/react';

export const generateCardStyles = (theme: Theme) => ({
    wrapper: {
        minHeight: '136px',
    },
    imgWrapper: {
        minHeight: '136px',
        border: `1px solid ${theme.palette.secondary.borderGrey}`,
        width: '100%',
        height: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'auto 100%',
        backgroundPosition: '-20px 20px',
        overflow: 'hidden',
        borderRadius: '8px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        '& .preview': {
            overflow: 'hidden',
            boxSizing: 'border-box',
            padding: '10px',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(13, 11, 11, 0.6)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: theme.palette.common.previewTextColor,
            fontSize: '14px',
            lineHeight: 1.4,
            fontWeight: 'normal',
            fontFamily: theme.palette.common.font,
            textAlign: 'center',
            cursor: 'pointer',
            transform: 'translateY(100%)',
            transition: 'transform 0.3s ease',
        },
        '&:hover .preview': {
            transform: 'translateY(0%)',
        },
    },
    img: {
        height: '66px',
    },
    description: {
        display: 'none',
    },
    link: {
        display: 'block',
        textDecoration: 'none',
        fontSize: '16px',
        fontFamily: theme.palette.common.font,
        color: theme.palette.primary.deepBlue,
        fontWeight: 500,
    },
});
